import { useEffect } from 'react'

export function useMobileViewportAdjustment(isMobileDevice: boolean) {
  useEffect(() => {
    if (isMobileDevice) {
      const handleViewportChange = () => {
        const wrapper = document.getElementById('app-wrapper') as HTMLDivElement

        if (window.visualViewport && wrapper && wrapper?.style) {
          wrapper.style.height = `${window.visualViewport.height}px`
        }
      }

      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', handleViewportChange)

        window.visualViewport.addEventListener('scroll', handleViewportChange)
      }

      handleViewportChange()

      return () => {
        if (window.visualViewport) {
          window.visualViewport.removeEventListener(
            'resize',
            handleViewportChange,
          )

          window.visualViewport.removeEventListener(
            'scroll',
            handleViewportChange,
          )
        }
      }
    }
  }, [isMobileDevice])
}
